import { Component, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { countdown, Countdown } from '../utils/countdown';
import { tap } from 'rxjs';

/**
 *Componente dialogo para mostrar un aviso de expiracion
 *por inactividad
 * @export
 * @class InactivityListenerComponent
 * @implements {AfterViewInit}
 */
@Component({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'inactivity-listener',
  templateUrl: './inactivity-listener.component.html',
  styleUrls: ['./inactivity-listener.component.scss'],
})
export class InactivityListenerComponent implements AfterViewInit {
  countdown!: Countdown;

  constructor(
    private ref: MatDialogRef<InactivityListenerComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) private data: { exp: number }
  ) {}

  /**
   *Inicia cuenta regresiva para la expiracion de la sesion
   *y su cierre automatico
   * @memberof InactivityListenerComponent
   */
  ngAfterViewInit(): void {
    countdown(this.data.exp)
      .pipe(
        tap((countdown) => {
          if (countdown.finished) {
            this.ref.close(false);
          }
        })
      )
      .subscribe((countdown) => this.countdown = countdown);
  }

  /**
   * The function closes the dialog, and then sends an event to Google Analytics
   */
  extendSession() {
    this.ref.close(true);
  }

  get seconds(){
    return  this.countdown?.seconds ? this.countdown?.s : `${this.countdown?.seconds % 60}`
    // return `${this.countdown?.seconds % 60}`
  }

  get minutes(){
    return `${this.countdown.minutes < 10 && '0'}${this.countdown.minutes}`
  }
}
